var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"guide-card"},[_c('div',{staticClass:"icon"}),_vm._m(0),_c('div',{staticClass:"sub-title"},[_vm._v(" 完整资料获取更多优质安源！ ")]),_c('veui-button',{staticClass:"btn",on:{"click":_vm.jumpMaterial}},[_vm._v("立即完善")])],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v(" 您有"),_c('span',[_vm._v("几项")]),_vm._v("认证信息待补充 ")])
}]

export { render, staticRenderFns }